import axios from 'axios';

export default axios.create({
  baseURL: 'https://youtube.googleapis.com/youtube/v3/',
  params: {
    part: 'snippet',
    maxResults: 255,
    playlistId: 'PLPgQ__36nJyUCOlZeBSGcK3FAAnQTC3qa', //replace with ur play list id
    key: 'AIzaSyCuUzXo_9EgDfjnyeQg0Yhx_AWz8ZF2rkE', // replace with your actual API Key
  },
});